import React from "react";
import Barcode from "../Barcode";

/**
 * Picker badges, bank-card size (85.6 × 54 mm), eight to an A4 with dashed cutting lines. Laminate
 * them: the badge is scanned with the handheld's scanner at the start of every shift (HVC-54).
 */
export const BADGE_CARD = { widthMm: 85.6, heightMm: 54, perPage: 8 };

const BadgeCardSheet = React.forwardRef(({ cards }, ref) => (
  <div
    ref={ref}
    style={{
      width: "190mm",
      fontFamily: "Arial, Helvetica, sans-serif",
      color: "#000",
      background: "#fff",
      display: "grid",
      gridTemplateColumns: `${BADGE_CARD.widthMm}mm ${BADGE_CARD.widthMm}mm`,
      columnGap: "6mm",
      rowGap: "4mm",
    }}
  >
    {(cards || []).map((card) => (
      <div
        key={card.code}
        data-badge={card.code}
        style={{
          width: `${BADGE_CARD.widthMm}mm`,
          height: `${BADGE_CARD.heightMm}mm`,
          border: "0.3mm dashed #000",
          boxSizing: "border-box",
          padding: "4mm",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          breakInside: "avoid",
          pageBreakInside: "avoid",
        }}
      >
        <div>
          <div style={{ fontSize: "2.8mm", textTransform: "uppercase", letterSpacing: "0.3mm" }}>Pickerpasje · Het Vleescentrum</div>
          <div style={{ fontSize: "7mm", fontWeight: 800, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{card.name || " "}</div>
        </div>
        <Barcode value={card.code} moduleMm={0.33} heightMm={14} showValue fontSizeMm={2.6} />
      </div>
    ))}
  </div>
));

export default BadgeCardSheet;
